import type { IconSvgObject } from './types';

const CodeIcon: IconSvgObject = [
  ["path", { d: "M16 7L21 12L16 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 7L3 12L8 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CodeIcon;
